import { setupSGWTConnect } from '@sgwt/connect-core';

const sgConnectConfig = window.sgmeConfiguration.sgConnect;

const cookieFakeClientId = document.cookie
  .split(';')
  .filter(r => r.trim().startsWith('Fake_ClientId'))
  .map(r => r.trim().split('=')[1])?.[0];

if (cookieFakeClientId?.length > 0) {
  sgConnectConfig.client_id = cookieFakeClientId;
}

setupSGWTConnect(sgConnectConfig);
